import React, { useEffect, useState } from "react";
import { Form, Alert, Collapse } from "react-bootstrap";
import DropDown from "../../../../../DropDown/DropDown";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { useNavigate, useParams } from "react-router-dom";
import format from "date-fns/format";
import { MdAddCircle } from "react-icons/md";
import ApiResponseHandler from "../../../../../../MasonyFixingsAPIs/ApiResponseHandler";
import { useToast } from "../../../../../../Contexts/ToastContext";
import UserAccountAPIs from "../../../../../../MasonyFixingsAPIs/UserAccountAPIs/UserAccountAPIs";

export default function AddProjectTask({handleAddNew}){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate(); 
    const [sending, setSending] = useState(false);
    const [addTask, setAddTask] = useState(false);
    const [incorrectDates, setIncorrectDates] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState({});

    const [stageID, setStageID] = useState('');
    const [taskID, setTaskID] = useState('');
    const [companyID, setCompanyID] = useState('');
    const [taskTypeID, setTaskTypeID] = useState('');
    const [approxVal, setApproxVal] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [userID, setUserID] = useState('');


    const handleChangeStage = (e) => {
        setStageID(e.target.value);
        setTaskID('');
        setTaskTypeID('');
    }
    const handleChangeTask = (e) => {
        setTaskID(e.target.value);
        setTaskTypeID('');
    }

    const handleCancel = () => {
        if(addTask){
            setStageID('');
            setTaskID('');
            setCompanyID('');
            setTaskTypeID('');
            setApproxVal('');
            setStartDate('');
            setEndDate('');
            setUserID(loggedInUser.id ?? '');
            setIncorrectDates(false);
        }
        setAddTask(!addTask);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setSending(true);
        setIncorrectDates(false);

        const postJSON = {
            task_id: taskID === '' ? null : taskID,
            company_id: companyID === '' ? null : companyID,
            task_type_id: taskTypeID === '' ? null : taskTypeID,
            approx_val: approxVal === '' ? null : approxVal,
            start_date: startDate === '' ? null : startDate,
            end_date: endDate === '' ? null : endDate,
            user_id: userID === '' ? null : userID
        }

        if(startDate && endDate){
            if((format(new Date(startDate), 'T')) > (format(new Date(endDate), 'T'))){
                setIncorrectDates(true);
                setSending(false);
            }
        }
        
        ProjectAPIs.PostProjectTask(params.ProjectID, postJSON)
        .then((response) => {
            if(response.status === 200){
                handleAddNew();
                setSending(false);
                setAddTask(false);
                handleCancel();
                addToast({ message: "Task added successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            ApiResponseHandler(err.response, navigate);
        })
        
        
    }

    const getUserDetails = () => {
        UserAccountAPIs.GetUserAccount()
        .then((response) => {
            if(response.status === 200){
                setLoggedInUser(response.data);
                setUserID(response.data.id);
            }
        })
        .catch((err) => {
            ApiResponseHandler(err.response, navigate);
        })
    }

    useEffect(() => {
        getUserDetails();
    }, [])

    return(
        <div className="project-section">
        <Form onSubmit={handleSubmit}>

            <div className="project-header-actions">
                <button
                    disabled={sending || !addTask}
                    type="submit"
                    className="save-btn"
                    style={addTask ? {display: 'block'} : {display: 'none'}}
                >
                    {sending ? 'Saving...' : 'Save'}
                </button>

                    <button
                        disabled={sending}
                        type="button"
                        className="cancel-btn"
                        onClick={() => handleCancel()}
                    >
                        {addTask ? 'Cancel' : <><MdAddCircle /> Add New</>}
                    </button>
                
            </div>
            <Collapse in={addTask}>
            <div className="project-section-body">

                <div className="project-section-body-column">

                
                    <div className="project-section-body-item m-1">
                        <span className="label">Stage:</span>
                        <DropDown.Stage className='editable-field' required value={stageID} onChange={handleChangeStage} />
                    </div>

                    <div className="project-section-body-item m-1">
                        <span className="label">Task:</span>
                        <DropDown.StageTasks stageID={stageID} disabled={sending || stageID==='' } required value={taskID} onChange={handleChangeTask} />
                    </div>
                    <div className="project-section-body-item m-1">
                    <span className="label">Type:</span>
                    <DropDown.TaskType className='editable-field'  taskID={taskID} disabled={sending || taskID===''} required value={taskTypeID} onChange={(e) => setTaskTypeID(e.target.value)} />
                </div>

                    
                </div>

                <div className="project-section-body-column">

                
                <div className="project-section-body-item m-1">
                    <span className="label">Sales Rep:</span>
                    <DropDown.Users className='editable-field' value={userID} disabled={sending} onChange={(e) => setUserID(e.target.value)} />
                </div>
                

                <div className="project-section-body-item m-1">
                    <span className="label">Start Date:</span>
                    <Form.Control className='editable-field'  isInvalid={incorrectDates} disabled={sending} type="date"  value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                </div>
                <div className="project-section-body-item m-1">
                    <span className="label">End Date:</span>
                    <Form.Control className='editable-field form-control' disabled={sending} isInvalid={incorrectDates} type='date'  value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                </div>

                </div>

                
                <div className="project-section-body-column">

                
                <div className="project-section-body-item m-1">
                        <span className="label">Company:</span>
                        <DropDown.AllCompanies className='editable-field' disabled={sending}  value={companyID} onChange={(e) => setCompanyID(e.target.value)} />
                    </div>

                
                
                <div className="project-section-body-item m-1">
                    <span className="label">Approx Value:</span>
                    <Form.Control className='editable-field' disabled={sending}  type="number" value={approxVal} onChange={(e) => setApproxVal(e.target.value)} />
                </div>

                </div>

                

            </div>
            </Collapse>
            {(incorrectDates && addTask) && <Alert variant="danger">End Date cannot be before Start Date</Alert>}
        </Form>
        </div>
    )


}